import { UPTMSG } from 'src/Helper/toastmsg';
import { FETCH_COMPANY, UPSERT_COMPANY, CLEAR_COMPANY_STATE, CLEAR_COMPANY_TEMP_STATES, FETCH_LOGO } from '../../../../Helper/actionsTypes';

const CompanyReducer = (state = [], action, props) => {
  switch (action.type) {
    case FETCH_COMPANY: {
      return action.payload.code === 200
        ? { ...state, details: action.payload.results[0] }
        : { ...state, details: null };
    }
    case UPSERT_COMPANY: {
      return action.payload.code === 200
        ? { ...state, itemSaved: true, cDetails: action.payload.results, message: action.payload.message }
        : action.payload.code === 404 ? { ...state, itemSaved: false, badReq: true, message: action.payload.message }
          : action.payload.code === 500 ? { ...state, itemSaved: false, message: UPTMSG }
            : { ...state, itemSaved: false, message: action.payload.message }
    }
    case FETCH_LOGO: {
      return action.payload.code === 200 ? { ...state, logo: action.payload.results.logo_path } : { ...state, logo: null }
    }
    case CLEAR_COMPANY_TEMP_STATES: return { ...state, itemSaved: null, message: null, badReq:null };
    case CLEAR_COMPANY_STATE: return {};
    default: return state;
  }
};

export default CompanyReducer;